/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component} from '@angular/core';

import requestHtml from './adn-request.html';
import layoutHtml from './adn-layout.html';
import utilityHtml from './adn-utility.html';
import feedbackHtml from './adn-feedback.html';

@Component({
  standalone: false,
  selector: 'adn-docs-page',
  template: `
    <p>adn.js is a script that provides a whole bunch of functionality within a user's browser for the Adnuntius platform. The headings of the tabs below describe the areas of functionality that adn.js provides.</p>
    <p>The human-readable version of the script is at <a href="http://cdn.adnuntius.com/adn.src.js">http://cdn.adnuntius.com/adn.src.js</a>
      while the minimised version of the script is at <a href="http://cdn.adnuntius.com/adn.js">http://cdn.adnuntius.com/adn.js</a>.
    </p>

    <tabset>
      <tab heading="Requesting an Ad">
        <div [innerHTML]="requestHtml | safeHtml"></div>
      </tab>
      <tab heading="Layout Support">
        <div [innerHTML]="layoutHtml | safeHtml"></div>
      </tab>
      <tab heading="Utility Methods">
        <div [innerHTML]="utilityHtml | safeHtml"></div>
      </tab>
      <tab heading="Feedback Options">
        <div [innerHTML]="feedbackHtml | safeHtml"></div>
      </tab>
    </tabset>
  `
})
export class AdnDocsPageComponent {
  readonly requestHtml = requestHtml;
  readonly layoutHtml = layoutHtml;
  readonly utilityHtml = utilityHtml;
  readonly feedbackHtml = feedbackHtml;
}
